import { Link } from "react-router-dom";
import React from "react";
import Image from "utils/imageLoader";
import { apiClient } from "sessions/server";

export const Goodies = () => {
    const [projects, setProjects] = React.useState([]);

    React.useEffect(() => {
        apiClient
            .get("/prototype/public_prototypes/")
            .then((response) => setProjects(response.data))
            .catch((error) => console.error("Error retrieving prototypes:", error));
    }, []);

    return (
        <main>
            <section className="section">
                <div className="container">
                    <h1 className="section-title">3D Printable Prototypes</h1>
                    <p className="lead">
                        Explore our collection of free 3D printable designs.
                        Each project includes STL files and printing
                        instructions.
                    </p>
                </div>
            </section>

            <section className="section">
                <div className="container">
                    <div className="projects-grid">
                        {projects != null && projects.length > 0 && projects.map((project) => (
                            <div key={project.uuid} className="project-card">
                                <Image
                                    fileName={project.preview_image_url}
                                    alt={project.name}
                                    className="project-image"
                                    loading="lazy"
                                />
                                <div className="project-content">
                                    <h3>{project.name}</h3>
                                    <p>{project.summary}</p>
                                    <Link
                                        to={`/goodies/${project.uuid}`}
                                        className="btn btn-ghost"
                                    >
                                        View Project
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </main>
    );
};
